module.exports = __webpack_public_path__ + "img/first-floor.70f6a2a2.jpg";